var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Rank',{attrs:{"options":_vm.responseitems,"fields":_vm.fields,"value":_vm.valueObj},on:{"input":function($event){return _vm.valueInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }